import axios from 'axios';

/*
*  This file contains all axios calls related to tag applied goal operations
*/

export const loadTags = async () => {
    const { data } = await axios.get('/app/tagAppliedGoal/tags/list');

    return data;
};

export const mapTagInfoToTagList = async (tagInfoList) => {
    const categories = [];

    Object.keys(tagInfoList).forEach((key) => {
        if (tagInfoList[key].label) {
            categories.push({ label: tagInfoList[key].label, id: tagInfoList[key].value.toString().replace('L', '') });
        }
    });

    return categories;
};

export const mapTagInfoToCategorizedTagList = async (tagInfoList) => {
    const categories = [];
    const tags = [];

    try {
        const { tagDTOList } = await loadTags();

        tagDTOList.forEach((tagDTO) => {
            if (tagDTO?.name && tagDTO?.id) {
                tags.push({
                    label: tagDTO.name,
                    value: tagDTO.id,
                    category: tagDTO.category?.id,
                    icon: 'tag',
                    categoryName: tagDTO.category?.name ? `${tagDTO.category?.name} >` : '',
                });
            }
        });

        categories.push({ label: 'Uncategorized', options: tags.filter((option) => option.category === 0) });

        Object.keys(tagInfoList).forEach((key) => {
            if (tagInfoList[key].label) {
                categories.push({ label: tagInfoList[key].label, options: tags.filter((option) => tagInfoList[key].value === option.category) });
            }
        });
    } catch (error) {
        this.$error({ message: 'Unable to load tags' });
    }

    return categories;
};

export const loadCategories = async () => {
    const { data } = await axios.get('/app/tagAppliedGoal/tagCategoryInfo');
    const { tagInfoList } = data;

    return mapTagInfoToTagList(tagInfoList);
};

export const loadCategorizedTags = async () => {
    const { data } = await axios.get('/app/tagAppliedGoal/tagCategoryInfo');
    const { tagInfoList } = data;

    return mapTagInfoToCategorizedTagList(tagInfoList);
};

export const createNewTag = async (newTagObj) => {
    const response = await axios.post('/app/tagAppliedGoal/createTag', newTagObj);

    return response;
};

export const createNewCategory = async (newTagObj) => {
    const response = await axios.post('/app/tagAppliedGoal/createTagCategory', newTagObj);

    return response;
};
